import type {LidarTechnology} from '@/domain/entities/LidarTechnology';
import type {LidarTechnologyRepository} from '@/domain/interfaces/LidarTechnologyRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {LidarTechnologyDto} from './LidarTechnologyDto';
import {toDomain} from './LidarTechnologyMappers';

const PATH = 'lidar-technologies/';

export class RestLidarTechnologyRepository implements LidarTechnologyRepository {
  constructor(private readonly httpClient: HttpClient) {}
  getAll = async () => {
    const lidarTechnologyDtos = await this.httpClient.get<Array<LidarTechnologyDto>>(PATH);
    return lidarTechnologyDtos.map((dto) => toDomain(dto));
  };

  create = async (_entity: LidarTechnology) => {
    throw new Error('Method not implemented.');
  };

  delete = async (_uuid: string) => {
    throw new Error('Method not implemented.');
  };

  getById = async (_uuid: string) => {
    throw new Error('Method not implemented.');
  };

  patch = async (_entity: LidarTechnology) => {
    throw new Error('Method not implemented.');
  };
}
